/* eslint strict: "off" */
/*es5-ext/global*/
function _(require, module, exports) {
    module.exports = function () {
        return this;
    }();
}